import { render } from "./signature-double-authentification.vue?vue&type=template&id=68afbcf7&scoped=true"
import script from "./signature-double-authentification.vue?vue&type=script&lang=js"
export * from "./signature-double-authentification.vue?vue&type=script&lang=js"

import "./signature-double-authentification.vue?vue&type=style&index=0&id=68afbcf7&scoped=true&lang=css"

import exportComponent from "/Users/bettachristian-david/Documents/Accen/ALL_REPO/Web-apps/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68afbcf7"]])

export default __exports__